import { render, staticRenderFns } from "./TaskGroupSelect.vue?vue&type=template&id=29448190&"
import script from "./TaskGroupSelect.vue?vue&type=script&lang=js&"
export * from "./TaskGroupSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports